import React from "react";
import { welcomeText } from "../data/config";
import { useHistory } from "react-router-dom";

const Network = () => {
  const history = useHistory();

  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  const marginTop = {
    marginTop: isMobile ? "20px" : "",
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <div className="grid-container" id={isMobile ? "join-banner" : ""}>
          <div className="grid-x grid-margin-x align-center">
            <div className="cell large-7 text-center">
              <div style={{ paddingBottom: "4rem" }}>{welcomeText}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-container join-content">
        <div className="grid-x grid-margin-x align-center">
          <div className="cell large-10 xlarge-9">
            <div className="box">
              <div className="page is-active is-loaded" style={marginTop}>
                <div className="box-header">
                  <legend>There was an issue with your network connection.</legend>
                </div>
                <div className="box-content">
                  <fieldset className="box-section">
                    <h3 className="box-section-heading">
                      Please hit the button below to refresh the page.
                    </h3>
                    <p className="input-wrapper">
                    If you continue to have an issue please
                      contact our membership department at (512) 555-1212 or by
                      email at{" "}
                      <a href="mailto:membership@aanp.org">
                        membership@aanp.org
                      </a>.
                    </p>
                    <div
                            className="text-center"
                            style={{ marginTop: "20px" }}
                          >
                    <button
                        type="submit"
                        className="button"
                        onClick={() => history.push("/start")}
                    >
                        Refresh
                    </button></div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Network;
